module.exports = __webpack_public_path__ + "static/media/arrow-right-s-line.0ef74134.svg";